import type { ErrorEvent, EventHint } from '@sentry/browser';
import { init, replayIntegration, setTag, thirdPartyErrorFilterIntegration } from '@sentry/browser';
import HttpError from '@naturehouse/nh-essentials/lib/requests/HttpError';
import { FeatureToggle, isFeatureEnabled } from '../../util/featureToggle';

init({
    dsn: process.env.SENTRY_DSN,
    // Want to test beforeSend in development? Comment out the thirdPartyErrorFilterIntegration
    beforeSend: (event: ErrorEvent, hint: EventHint | null): ErrorEvent | null => {
        const errorValue = event.exception?.values?.[0]?.value;

        if (!hint) {
            return event;
        }

        const error = hint.originalException;

        if (
            error instanceof HttpError ||
            errorValue?.includes('Java object is gone') ||
            errorValue?.includes('fbq is not defined')
        ) {
            return null;
        }

        return event;
    },
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.1,
    integrations: [
        replayIntegration(),
        thirdPartyErrorFilterIntegration({
            filterKeys: [process.env.SENTRY_APP_KEY ?? ''],
            behaviour: 'drop-error-if-exclusively-contains-third-party-frames'
        })
    ],
    ignoreErrors: ['TurnstileError']
});

const isLandlord = document.body.classList.contains('userIsLandlord');
setTag('is-landlord', isLandlord.toString());
setTag('deployment-environment', document.documentElement.dataset.deploymentEnv);

const featuresEnabled = Object.values(FeatureToggle)
    .map((feature): string => (isFeatureEnabled(feature) ? feature : ''))
    .filter(Boolean);

if (featuresEnabled.length) {
    setTag('features-enabled', featuresEnabled.join(','));
}
